import { connect } from 'react-redux';

import moment from 'moment';
import momentTimezone from 'moment-timezone';
import {
  reduxForm,
  change,
  reset,
  focus,
  arrayPush,
  getFormValues,
} from 'redux-form';

// Actions
import {
  createEvent,
  updateEvent,
  selectEvent,
  fetchSuggestedRsvpQuestions,
  fetchSuggestedAttireOptions,
} from '../../../../actions/EventActions';
import {
  updateEventV2,
  addEventV2,
} from '../../../../actions/website/entities/EventActions';
import {
  hideModal,
} from '../../../../actions/ModalActions';
import {
  getPlaceDetails,
  resetAddress,
} from '../../../../actions/PlacesActions';

// Components
import EventForm from './EventFormV2';


export const formatEventDate = (form) => {
  const dateString = moment.utc(form.date, 'MM-DD-YYYY').format('MM-DD-YYYY');
  const startAt = moment.utc(`${dateString} ${form.start_at.hour}:${form.start_at.minute}`, 'MM-DD-YYYY h:mm a');
  const endAt = form.end_at ? moment.utc(`${dateString} ${form.end_at.hour}:${form.end_at.minute}`, 'MM-DD-YYYY h:mm a') : '';
  if (endAt !== '' && endAt.isBefore(startAt)) {
    endAt.add(1, 'd');
  }
  const timezone = momentTimezone.tz.guess();
  const formattedForm = Object.assign({}, form, { start_at: startAt.format(), end_at: endAt !== '' ? endAt.format() : null, end_time: endAt !== '' ? form.end_time : null, timezone });
  return formattedForm;
};

const formatDateForEdit = (form) => {
  if (!form.date) {
    const start = moment.utc(form.start_at);
    const end = moment.utc(form.end_at);

    return {
      date: moment.utc(form.start_at),
      start_at: { hour: start.format('H'), minute: start.format('m') },
      end_at: end.isValid() ? { hour: end.format('H'), minute: end.format('m') } : undefined,
    };
  }
  return undefined;
};

const formatNewDate = date => ({
  date: date ? moment.utc(date) : moment.utc()
});

const mapStateToProps = (state, ownProps) => {
  const event = state.events.events.byId[state.events.events.selectedId] || state.website.entities.byId[state.website.entities.selectedEntityId];
  const selectedId = state.events.events.selectedId || state.website.entities.selectedEntityId;
  const weddingDate = state.wedding.wedding.wedding_date;
  const formatDate = selectedId ? formatDateForEdit(event) : formatNewDate(weddingDate);
  const isCollectRsvp = ownProps ? ownProps.collectRsvps : false;
  const rsvpSuggestions = state.events.rsvp.suggestions;
  const { suggestedAttireOptions } = state.events.events;
  const eventProps = selectedId ? {} : { start_at: { hour: 18, minute: 0 }, public: true, collect_rsvps: isCollectRsvp, country_code: 'US' };
  const address = state.events.events.address || state.website.entities.address;
  const numberOfEvents = ownProps ? ownProps.numberOfEvents : undefined;
  const numberOfGuests = ownProps ? ownProps.numberOfGuests : undefined;

  return ({
    initialValues: Object.assign(
      {},
      event,
      formatDate,
      eventProps
    ),
    address,
    rsvpSuggestions,
    suggestedAttireOptions,
    selectedId,
    formValues: getFormValues('eventForm')(state) || {},
    numberOfEvents,
    numberOfGuests,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (eventFormRequest) => {
    const {
      onSubmitOverride,
      websiteEvent,
      handleEventFormClose,
    } = ownProps;
    const req = formatEventDate(eventFormRequest);
    const updateEventAction = websiteEvent ? updateEventV2 : updateEvent;
    const createEventAction = websiteEvent ? addEventV2 : createEvent;

    if (onSubmitOverride) {
      return onSubmitOverride(req);
    } if (eventFormRequest.id) {
      return dispatch(updateEventAction(req))
        .then(() => dispatch(hideModal()))
        .catch(() => dispatch(reset('eventForm')));
    }
    return dispatch(createEventAction(req))
      .then(() => dispatch(hideModal()))
      .then(() => handleEventFormClose());
  },
  getSuggestion: suggestionData => dispatch(getPlaceDetails(suggestionData.placeId, suggestionData.label, 'venue_name')),
  handleAddress: (address) => {
    Object.keys(address).filter(key => !!address[key]).map(key => (
      dispatch(change('eventForm', key, address[key]))
    ));
  },
  onResetAddress: (address) => {
    dispatch(resetAddress());
    Object.keys(address).map(key => dispatch(change('eventForm', key, '')));
    dispatch(change('eventForm', 'country_code', 'US'));
  },
  onResetAddressSearch: () => dispatch(resetAddress()),
  onSelectEvent: id => dispatch(selectEvent(id)),
  getRsvpSuggestions: () => dispatch(fetchSuggestedRsvpQuestions()),
  setQuestion: ({ question, id }) => dispatch(arrayPush('eventForm', 'rsvp_questions', {
    question,
    suggested_rsvp_question_id: id,
    editing: true
  })),
  getSuggestedAttireOptions: () => dispatch(fetchSuggestedAttireOptions()),
  setAttire: (attire) => {
    dispatch(focus('eventForm', 'attire'));
    dispatch(change('eventForm', 'attire', attire.attire));
    dispatch(change('eventForm', 'suggested_attire_option_id', attire.id));
  },
  setEventName: (name) => {
    dispatch(change('eventForm', 'name', name));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'eventForm',
  validate: (values) => {
    if (values.venue_name && values.venue_name.length > 50) {
      return { venue_name: 'Must be 50 characters or less' };
    }
    return undefined;
  }
})(EventForm));



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/EventFormContainerV2.jsx